import { RecurringOption } from "../../types/block/enum";

export const recurringOptions = [
  RecurringOption.THIS,
  RecurringOption.THISANDAFTER,
  RecurringOption.ALL,
] as const;
